import {listMaterialFunctionsSearchSchema} from "@project/application/engineering/material-functions";
import {createFileRoute, redirect} from "@tanstack/react-router";

function parseLegacyMaterialFunctionsSearch(search: unknown) {
  const parsed = listMaterialFunctionsSearchSchema.parse(search);

  return {
    ...parsed,
    state: parsed.state === "DELETED" ? ("DELETED" as const) : ("ACTIVE" as const),
  };
}

export const Route = createFileRoute("/_app/engineering/material-functions/")({
  beforeLoad: ({search}) => {
    throw redirect({
      replace: true,
      search: parseLegacyMaterialFunctionsSearch(search),
      to: "/engineering/materials/functions",
    });
  },
  validateSearch: parseLegacyMaterialFunctionsSearch,
});
